import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles } from 'utils-next/types'

import { TableCell, Theme } from '@mui/material'

export type TableHeaderCellProps = ExtendableStyles & {
  render: (type: 'Header' | 'Footer' | string, props?: object) => React.ReactNode
}

export function TableHeaderCell({ className, style, render }: TableHeaderCellProps) {
  const { classes } = useStyles()
  return (
    <TableCell component="th" className={classNames(className, classes.tableHeaderCell)} style={style}>
      {render('Header')}
    </TableCell>
  )
}

const useStyles = makeStyles()(({ typography }: Theme) => ({
  tableHeaderCell: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    ...(typography.body1 as any),
    fontWeight: typography.fontWeightMedium,
  },
}))
